import { render, staticRenderFns } from "./FootbowlAction.vue?vue&type=template&id=4ebe1fc1&scoped=true&"
import script from "./FootbowlAction.vue?vue&type=script&lang=ts&"
export * from "./FootbowlAction.vue?vue&type=script&lang=ts&"
import style0 from "./FootbowlAction.vue?vue&type=style&index=0&id=4ebe1fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe1fc1",
  null
  
)

component.options.__file = "FootbowlAction.vue"
export default component.exports